import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import FindModuleById from '.././FindModuleById';

import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const ViewUser = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
      setPermission(FindModuleById(1)); 
       console.log(permission);
    axios
      .get(`/users/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);
        if (response.data.code === 200) {
          setValue(response.data.data.user);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);


  if(value.profile_picture){
      AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
      AWS.config.update({
          accessKeyId: AWS_ACCESS_KEY_ID,
          secretAccessKey: AWS_SECRET_ACCESS_KEY,
          region: AWS_DEFAULT_REGION,
          signatureVersion: 'v4',
      });
      const s3 = new AWS.S3();
      var params = {Bucket: AWS_BUCKET, Key: value.profile_picture};
      var user_iamge = s3.getSignedUrl('getObject', params);
      
  }



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Users</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/users">Users</Link>
                    </li>
                    <li className="breadcrumb-item active">View User</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View User Information</h4>
                    <table className="table table-bordered">

                   <tbody>
                      <tr>
                        <th className="p-3">Profile Image</th>
                        <td className="p-3">
                        <img
                                className="avatar-img"
                                src={user_iamge}
                                alt="Profile Image"
                                width={200}
                                height={200}
                              />
                          </td>
                      </tr>
                      <tr>
                        <th className="p-3">First Name</th>
                        <td className="p-3">{value.first_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Last Name</th>
                        <td className="p-3">{value.last_name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Role</th>
                        <td className="p-3">
                          {value.role_id ? value.role.title : ""}
                        </td>
                      </tr>
                      {value.customer &&(
                         <tr>
                         <th className="p-3">Company Name </th>
                         <td className="p-3">
                           {value.customer ? value.customer.company_name : ""}
                         </td>
                       </tr>
                      )}
                      <tr>
                        <th className="p-3">Email</th>
                        <td className="p-3">{value.email}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Phone Number</th>
                        <td className="p-3">{value.phone_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">User Location</th>
                        <td className="p-3">
                          {value.user_location ? value.location.title : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">User Position</th>
                        <td className="p-3">{value.user_position}</td>
                      </tr>
                    
                      <tr>
                        <th className="p-3">Status</th>
                        <td className="p-3">
                          {value.user_status ? value.user_status.title : ""}
                        </td>
                      </tr>
                   </tbody>
                    </table>
                    <br />
                    <h5 className="card-title">Access Modules</h5>

                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Name</th>
                        <th className="p-3">List</th>
                        <th className="p-3">Add</th>
                        <th className="p-3">Update</th>
                        <th className="p-3">Delete</th>
                      </tr>
                      {value.permissions &&
                        value.permissions.map((item, index) => (
                          <tr  key={item.module_title || index}>
                            <td className="p-3">{item.module_title}</td>
                            <td className="p-3">{(item.list ==1)?'YES':'NO'}</td>
                            <td className="p-3">{(item.add ==1)?'YES':'NO'}</td>
                            <td className="p-3">{(item.update ==1)?'YES':'NO'}</td>
                            <td className="p-3">{(item.delete ==1)?'YES':'NO'}
                              {item.module_title == 'HR => Employees' &&(
                                <div>
                                Fixed: 
                              {(item.other_1 ==1)?' YES':' NO'}
                                <br/> Seasonal: 
                              {(item.other_2 ==1)?' YES':' NO'}
                                </div>
                              )}

                            </td>
                          </tr>
                        ))}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewUser;
